import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  private readonly apiUrl = environment.apiBaseUrl;

  constructor(protected http: HttpClient) { }

  protected get<T>(endpoint: string, options: any = {}): Observable<any> {
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, options);
  }

  protected post<T>(endpoint: string, body: any, options: any = {}): Observable<any> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, body, options);
  }

  protected put<T>(endpoint: string, body: any, options: any = {}): Observable<any> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, body, options);
  }

  protected patch<T>(endpoint: string, body: any, options: any = {}): Observable<any> {
    return this.http.patch<T>(`${this.apiUrl}/${endpoint}`, body, options);
  }

  protected delete<T>(endpoint: string, options: any = {}): Observable<any> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, options);
  }

  protected getHeaders(body?: any): HttpHeaders {
    let headers = new HttpHeaders();
    if (!(body instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
}
